import {Action, action} from 'easy-peasy';

    interface AppConfigStoreModel {
        items: any[];
        loadConfigs: Action<AppConfigStoreModel, any[]>;
        loading: boolean;
        setLoading: Action<AppConfigStoreModel, boolean>;
    }

const appConfigStore: AppConfigStoreModel = {
    items: [],
    loadConfigs: action((state, configs) => {
        state.items = configs;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};

export default appConfigStore;